import { useState } from "react";
import { Box, Button, IconButton, Popover, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { IFilterSchema } from "../../../../utils/types";
import { handleApplyFilterItemFunction } from "./FiltersContainer";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface MoreFiltersProps {
  moreFilters: IFilterSchema[];
  onApply: handleApplyFilterItemFunction;
}

const MoreFilters: React.FC<MoreFiltersProps> = ({ moreFilters, onApply }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [itemSelected, setItemSelected] = useState<IFilterSchema | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
    setItemSelected(null);
  };
  const handleBackToList = () => {
    setItemSelected(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setItemSelected(null);
  };

  const handleSelect = (filter: IFilterSchema) => {
    setItemSelected(filter);
  };

  const handleApply = (column: string, operator: string, value: any) => {
    onApply(column, operator, value);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        disableRipple
        onClick={handleClick}
        sx={{
          textTransform: "none",
          borderRadius: "9999px",
          height: 28.5,
          px: 1,
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        <IconButton size="small">
          <AddIcon fontSize="small" />
        </IconButton>
        بیشتر
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            mr: 1,
            overflow: "visible",
            direction: "rtl",
          },
        }}
      >
        <Box sx={{ p: 2, minWidth: 280 }}>
          {!itemSelected ? (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <Typography variant="body1">فیلترهای بیشتر</Typography>
                <IconButton size="small" onClick={handleClose}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  maxHeight: "250px",
                  overflow: "auto",
                }}
              >
                {moreFilters.map((filter, i) => (
                  <Button
                    key={i}
                    fullWidth
                    onClick={() => handleSelect(filter)}
                    sx={{
                      textTransform: "none",
                      justifyContent: "start",
                      marginBottom: i === moreFilters.length - 1 ? 0 : "5px",
                    }}
                  >
                    {filter.props.label}
                  </Button>
                ))}
              </Box>
            </Box>
          ) : (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                  direction: "rtl",
                }}
              >
                <Typography variant="body1">
                  {`فیلتر بر اساس ${itemSelected.props.label}`}
                </Typography>
                <IconButton size="small" onClick={handleBackToList}>
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
              </Box>

              <itemSelected.FilterComponent
                handleApplyFilter={handleApply}
                value={itemSelected.props.value}
                operator={itemSelected.props.operator}
                columnName={itemSelected.props.columnName}
                options={itemSelected.options}
              />
            </Box>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default MoreFilters;
